import axiosInstance from './axiosInstance';
import { ResetUserPasswordRequestDto } from '@docbay/schemas';

/**
 * UserResetPassword service.
 */
export const UserResetPassword = {
  /**
   * Resets a user's password.
   *
   * @param params - The request payload containing the necessary information to reset the user's password.
   * @returns A promise that resolves with the response from the server.
   */
  resetPassword: (params: ResetUserPasswordRequestDto) =>
    axiosInstance.post<any>('/saas/reset-user-password', params),
};
